import * as React from 'react';
import {generatePath} from 'react-router-dom';
// @ts-expect-error
import type {ContextRouter} from 'react-router-dom';

import type {FormPublishInput} from 'nutshell-graphql-types';

import {FullPageFormEditor} from '../forms/form-page/full-page-form-editor-modal';
import {usePublishForm} from '../forms/graphql/graphql-wrappers/use-publish-form';
import type {ReportURLParams} from '../reports/report-types';
import {RouteContext} from '../route-context';

import {FormHeader} from './form-header';
import {useGetMeeting} from './graphql/hooks/use-get-meeting';
import {MeetingPage} from './meeting-page';

type Props = ContextRouter & {
    id: string;
    urlParams: ReportURLParams<'meetings'>;
    onParamChange: (arg1: any, arg2: boolean) => any;
};

export function MeetingPageWrapper(props: Props) {
    const {meeting, isLoading, refetch} = useGetMeeting(props.id);
    const publishForm = usePublishForm();

    const activeTab = props.match.params.tab || 'details';

    const setSelectedTab = (newTab: string) => {
        const newPath = generatePath(props.match.path, {
            meetingId: props.match.params.meetingId,
            tab: newTab,
        });

        props.history.push({
            pathname: newPath,
            search: props.history.location.search,
        });
    };

    if (!meeting) {
        return null;
    }

    return activeTab === 'editor' ? (
        <FullPageFormEditor
            history={props.history}
            location={props.location}
            match={props.match}
            form={meeting.form}
            formHeader={
                <FormHeader
                    name={meeting.name}
                    description={meeting.description}
                    durationMinutes={meeting.durationMinutes}
                    locationType={meeting.locationType}
                    location={meeting.location}
                    hostUser={meeting.creator}
                    cohostNames={meeting.cohosts.map(({name}) => name)}
                />
            }
            onClose={() => setSelectedTab('form')}
            onPublishForm={(input: FormPublishInput) => publishForm(input)}
            refetchForm={refetch}
            previewPath={generatePath('/scheduler/:publicFormId/:tab', {
                publicFormId: meeting.form.publicFormId,
                tab: 'preview',
            })}
            disableDesign={true}
            disableHeaderFields={true}
            minimumOneEmailField={true}
            isMeetingForm={true}
        />
    ) : (
        <RouteContext.Consumer>
            {({isEmbedded}) => {
                return (
                    <MeetingPage
                        {...props}
                        meeting={meeting}
                        isLoading={isLoading}
                        isEmbedded={isEmbedded}
                        activeTab={activeTab}
                        onSetSelectedTab={setSelectedTab}
                        refetchMeeting={refetch}
                        urlParams={props.urlParams}
                        onParamChange={props.onParamChange}
                    />
                );
            }}
        </RouteContext.Consumer>
    );
}
